import React, { useCallback } from "react";
import { matchPath } from "react-router-dom";
import { Heading, Text } from "rebass";
import { Location } from "history";

import RoutePrompt from "../../route/RoutePrompt";

interface IProps {
  recordId: string;
  title: string;
  dirty: boolean;
}

export const PromptLeaveRecord: React.FC<IProps> = ({ recordId, title, dirty }) => {
  const matchPathCallback = useCallback((location: Location) => {
    /* recordId is equal to empty string */
    if (!recordId) {
      return true;
    }

    const match = matchPath<{ id: string }>(location.pathname, "/record/:id");
    /* match is equal to null */
    if (!match) {
      return true;
    }

    const { params: { id } } = match;

    return id === recordId;
  }, [recordId]);

  return (
    <RoutePrompt
      when={dirty}
      matchPath={matchPathCallback}
    >
      <Heading
        as="h3"
        mb="28px"
        fontSize="32px"
        fontWeight="bold"
        lineHeight="1.34"
        color="#202020"
      >
        Leave record
      </Heading>

      <Text
        as="p"
        fontSize="18px"
        fontWeight={500}
        color="zodiac"
      >
        <span>Do you want to leave the record</span>

        &nbsp;

        <b>{title}</b>

        &nbsp;

        <span>without saving?</span>
      </Text>
    </RoutePrompt>
  );
};
